/**
 * FursInternalAct API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  generateFursInternalActDocx,
  generateFursInternalActPdf,
} from "../generated/furs-internal-act/furs-internal-act";

import { wrapMethod } from "./utils";

export const fursInternalAct = {
  /** @see generateFursInternalActPdf */
  generateFursInternalActPdf: wrapMethod(generateFursInternalActPdf),

  /** @see generateFursInternalActDocx */
  generateFursInternalActDocx: wrapMethod(generateFursInternalActDocx),
} as const;

export type FursInternalActApi = typeof fursInternalAct;
